import { Compass } from "lucide-react";
import { Reveal } from "@/components/wf/primitives";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer className="bg-surface border-t border-brand-teal/15" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <Reveal>
        <h2 className="font-serif text-[clamp(2.25rem,6vw,5.5rem)] leading-[1] tracking-tight text-brand-sand max-w-5xl">
          Wherever you're going, <span className="italic text-brand-aqua">we know the way there.</span>
        </h2>
      </Reveal>

      <div className="mt-20 grid md:grid-cols-3 gap-10 border-t border-brand-teal/20 pt-12">
        <div>
          <div className="flex items-center gap-3">
            <Compass className="w-5 h-5 text-brand-aqua" />
            <span className="font-serif text-lg text-brand-sand">WayFinder Pacific</span>
          </div>
          <p className="mt-4 font-sans text-sm text-brand-sand/60 max-w-xs">
            Destination management and logistics across Tuvalu and the wider Pacific.
          </p>
        </div>
        <div>
          <p className="font-sans text-xs tracking-[0.2em] uppercase text-brand-teal">Contact</p>
          <ul className="mt-4 space-y-2 font-sans text-sm text-brand-sand/70">
            <li>Funafuti, Tuvalu</li>
            <li>tuvalulogistics@gmail.com</li>
            <li>+688 7102399</li>
          </ul>
        </div>
        <div>
          <p className="font-sans text-xs tracking-[0.2em] uppercase text-brand-teal">Explore</p>
          <ul className="mt-4 space-y-2 font-sans text-sm">
            {[["What we do", "services"], ["Set-departure tours", "tours"], ["Signature events", "events"], ["Plan with us", "contact"]].map(([l, id]) => (
              <li key={id}>
                <button onClick={() => scrollTo(id)} className="text-brand-sand/70 hover:text-brand-aqua transition-colors" data-testid={`footer-link-${id}`}>{l}</button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p className="mt-16 font-sans text-xs text-brand-sand/40">© {new Date().getFullYear()} WayFinder Pacific · Based in Funafuti, Tuvalu</p>
    </div>
  </footer>
);
